const ItemTypes = {
  FEATURE: "feature"
}

export default ItemTypes;